module.exports = __webpack_public_path__ + "static/img/start.328c95dc.gif";